import React from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box, BoxProps } from 'components/ui';
import { ZIndex, getDesignToken, spacing } from 'styles/constants';
import { NAV_HEIGHT } from 'styles/constants/enums';

const headerIconPressedBg = getDesignToken('background-icon-header-contrast');

const headerIconContainerStyles = {
  zIndex: ZIndex.OVERLAY,
  _pressed: {
    backgroundColor: headerIconPressedBg,
  },
  _focus: {
    backgroundColor: headerIconPressedBg,
  },
  _hover: {
    backgroundColor: headerIconPressedBg,
    color: 'inherit',
  },
};

// The absolute position pops it out of the flex flow
// and this allows our centered logo to be truly centered and not offset by the menu item
export const MenuButtonContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.menuButtonContainer, style] });

export const Header = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.header, style] });

export const LinkNoDecoration = Link.withConfig({
  ...headerIconContainerStyles,
});

export const StyledCenterSpacer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.centerSpacer, style] });

export const StyledRightSpacer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.rightSpacer, style] });

export const StyledLogo = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    accessibilityLabel: 'Burger King Logo. Navigate to Home',
    accessibilityRole: 'link',
    style: [styles.logo, style],
  });

const styles = StyleSheet.create({
  menuButtonContainer: {
    flexShrink: 1,
    left: 0,
    position: 'absolute',
    zIndex: 1,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    height: NAV_HEIGHT.MOBILE,
    justifyContent: 'space-between',
    width: '100%',
  },
  centerSpacer: {
    alignItems: 'flex-end',
    flexGrow: 1,
  },
  rightSpacer: {
    alignItems: 'flex-end',
    flex: 1,
    flexDirection: 'row',
    gap: spacing.$4,
    justifyContent: 'flex-end',
  },
  logo: {
    justifyContent: 'center',
    marginHorizontal: 'auto',
  },
});
